var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZepcruitDoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166992,
    y: 0.166504,
    width: 58.6667,
    height: 58.6667,
    rx: 29.3333,
    fill: "#FFF3ED",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.38965,
    y: 6.38867,
    width: 46.2222,
    height: 46.2222,
    rx: 23.1111,
    fill: "#FF854A",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1673 29.5002C46.1673 38.7049 38.7054 46.1668 29.5007 46.1668C20.2959 46.1668 12.834 38.7049 12.834 29.5002C12.834 20.2954 20.2959 12.8335 29.5007 12.8335C38.7054 12.8335 46.1673 20.2954 46.1673 29.5002Z",
    fill: "#FF5D0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2185 24.4496C36.7067 24.9378 36.7067 25.7292 36.2185 26.2174L27.8852 34.5507C27.397 35.0389 26.6056 35.0389 26.1174 34.5507L22.7841 31.2174C22.2959 30.7292 22.2959 29.9378 22.7841 29.4496C23.2722 28.9615 24.0637 28.9615 24.5519 29.4496L27.0013 31.8991L30.726 28.1743L34.4508 24.4496C34.9389 23.9615 35.7304 23.9615 36.2185 24.4496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZepcruitDoneIcon);
export default __webpack_public_path__ + "static/media/zepcruitDoneIcon.21e5e305f4c64536f61d4a0c6b5b2f38.svg";
export { ForwardRef as ReactComponent };